import React from "react";
import ServicePage from "./ServicePage";

export default function FezabilitateDigitalaPage() {
  return (
    <ServicePage
      number="01"
      eyebrow="Serviciu digital"
      title={["Studiu de", "fezabilitate", "digitală."]}
      tagline="Experiență de peste 20 de ani în evaluarea nevoilor și pregătirea proiectelor de digitalizare."
      intro={[
        "Studiul de fezabilitate digitală analizează gradul de maturitate tehnologică a companiei tale și identifică cu precizie oportunitățile de eficientizare — o etapă esențială înainte de a intra într-un program european de digitalizare.",
        "Colaborăm îndeaproape cu echipa ta pentru a construi un dosar solid, aliniat cerințelor finanțatorului și obiectivelor de business.",
      ]}
      stepsEyebrow="Cum lucrăm"
      stepsTitle="Un flux de trei pași."
      steps={[
        {
          title: "Consultanță",
          desc: "Explorăm nevoile companiei și oferim soluții personalizate, aliniate cu profilul de activitate și cu obiectivele strategice.",
        },
        {
          title: "Planificare",
          desc: "Coordonăm și supraveghem fiecare fază a implementării proiectului — de la brief la calendar și repere de validare.",
        },
        {
          title: "Expertiză",
          desc: "Lucrăm în conformitate cu ghidurile de finanțare ale fiecărui proiect în parte, cu documente pregătite pentru audit.",
        },
      ]}
    />
  );
}
